module.exports = __webpack_public_path__ + "img/uwell.eafe6c7d.png";